/**
 * ClienteTabs - Tab navigation for cliente detail view
 */
import React from 'react';

export type ClienteTabType = 'dados' | 'produtos' | 'representantes' | 'hospitais' | 'pontos_contagem';

interface ClienteTabsProps {
  activeTab: ClienteTabType;
  setActiveTab: (tab: ClienteTabType) => void;
}

export const ClienteTabs: React.FC<ClienteTabsProps> = ({ activeTab, setActiveTab }) => {
  const tabs: { id: ClienteTabType; label: string }[] = [
    { id: 'dados', label: 'Dados Gerais' },
    { id: 'produtos', label: 'Produtos' },
    { id: 'hospitais', label: 'Hospitais Atendidos' },
    { id: 'pontos_contagem', label: 'Pontos de Contagem' },
    { id: 'representantes', label: 'Representantes' },
  ];

  return (
    <div className="flex gap-2 border-b-2 border-gray-200 dark:border-gray-700 px-0">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`px-5 py-3 text-sm font-medium transition-all ${
            activeTab === tab.id
              ? 'text-blue-600 border-b-[3px] border-blue-600 bg-gray-50 dark:bg-gray-900'
              : 'text-gray-500 border-b-[3px] border-transparent hover:text-blue-600 hover:bg-gray-100 dark:hover:bg-gray-800'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
